// extracted by mini-css-extract-plugin
export var boxItems = "_cp-1";
export var boxItemsLg = "_cp-2";
export var button = "_cp-7";
export var buttonHoverless = "_cp-9";
export var buttonLg = "_cp-8";
export var filterGroupBox = "_cp-0";
export var icon = "_cp-3";
export var iconSecondary = "_cp-6";
export var iconWrapper = "_cp-4";
export var iconWrapperLg = "_cp-5";
export var truncatedLabel = "_cp-a";